import {IGeneralColors} from './architecture/sections/general-colors.interface';
import { IBaseUIComponents } from './architecture/orbit-theme.interface';
import { ButtonPreset, IButtonPreset } from '../basic-ui-components/button/base/button-props.interface';

export function createBaseUIComponents(generalColors: IGeneralColors): IBaseUIComponents {
    return {
        button: {
            presets: {
                primary: {
                    colors: {
                        normal: {
                            text: generalColors.buttonDark, bg: generalColors.brandPrimary, border: generalColors.brandPrimary
                        },
                        hover: {
                            text: generalColors.brandPrimary, /*bg: generalColors.buttonDark,*/ bg: generalColors.bodyBackground, border: generalColors.brandPrimary
                        },
                        disabled: {
                            text: generalColors.buttonDark, bg: generalColors.brandPrimary, border: generalColors.brandPrimary
                        }
                    }
                },
                primaryInverted: {
                    colors: {
                        normal: {
                            text: generalColors.brandPrimary, /*bg: generalColors.buttonDark,*/ bg: generalColors.bodyBackground, border: generalColors.brandPrimary
                        },
                        hover: {
                            text: generalColors.buttonDark, bg: generalColors.brandPrimary, border: generalColors.brandPrimary
                        },
                        disabled: {
                            text: generalColors.brandPrimary, /*bg: generalColors.buttonDark,*/ bg: generalColors.bodyBackground, border: generalColors.brandPrimary
                        }
                    }
                },
                secondary: {
                    colors: {
                        normal: {
                            /*text: generalColors.bodyBackground,*/ text: generalColors.buttonDark, bg: generalColors.brandSecondary, border: generalColors.brandSecondary
                        },
                        hover: {
                            text: generalColors.brandSecondary, bg: generalColors.bodyBackground, border: generalColors.brandSecondary
                        },
                        disabled: {
                            /*text: generalColors.bodyBackground,*/ text: generalColors.buttonDark, bg: generalColors.brandSecondary, border: generalColors.brandSecondary
                        }
                    }
                },
                secondaryInverted: {
                    colors: {
                        normal: {
                            text: generalColors.brandSecondary, bg: generalColors.bodyBackground, border: generalColors.brandSecondary
                        },
                        hover: {
                            text: generalColors.bodyBackground, bg: generalColors.brandSecondary, border: generalColors.brandSecondary
                        },
                        disabled: {
                            text: generalColors.brandSecondary, bg: generalColors.bodyBackground, border: generalColors.brandSecondary
                        }
                    }
                },
                info: {
                    colors: {
                        normal: {
                            text: generalColors.buttonLight, bg: generalColors.buttonDark, border: generalColors.buttonInfo
                        },
                        hover: {
                            text: generalColors.buttonDark, bg: generalColors.buttonLight, border: generalColors.buttonDark
                        },
                        disabled: {
                            text: generalColors.buttonLight, bg: generalColors.buttonDark, border: generalColors.buttonInfo
                        }
                    }
                },
                warning: {
                    colors: {
                        normal: {
                            text: generalColors.buttonWarning, bg: generalColors.bodyBackground, border: generalColors.componentBackground
                        },
                        hover: {
                            text: generalColors.bodyBackground, bg: generalColors.buttonWarning, border: generalColors.buttonWarning
                        },
                        disabled: {
                            text: generalColors.buttonWarning, bg: generalColors.bodyBackground, border: generalColors.componentBackground
                        }
                    }
                },
                flatStroked: {
                    colors: {
                        normal: {
                            text: generalColors.buttonInfo, bg: generalColors.buttonDark, border: generalColors.buttonInfo
                        },
                        hover: {
                            text: generalColors.buttonLight, bg: generalColors.buttonDark, border: generalColors.buttonLight
                        },
                        disabled: {
                            text: generalColors.buttonInfo, bg: generalColors.bodyBackground, border: generalColors.buttonInfo
                        }
                    },
                    stroke: "light"
                }
            } as Record<ButtonPreset, IButtonPreset>,
            /**
             * All size values related to buttons (except stroke) are in EM.
             * This way all sizes will be relative to font-size on button:
             * For fixedSize=true the font-size of the button will be 10px so sizes are relative to 10px
             * For fixedSize=false the font-size of the button will be 1rem so sizes are relative to 1rem
             *
             * Stroke is in PX
             */
            strokeValues: {
                none: 0,
                light: 1,
                heavy: 2
            },
            sizeVariantValues: {
                regular: {
                    height: 4,
                    fontSize: 1.4,
                    iconSize: {
                        small: 1.8,
                        regular: 2.4,
                        large: 3
                    }
                },
                small: {
                    height: 3,
                    fontSize: 1.4,
                    iconSize: {
                        small: 1.35,
                        regular: 1.8,
                        large: 2.25
                    }
                }
            },
            defaults: {
                stroke: "heavy",
                rounded: true,
                elevated: false,
                fontSize: 1.4
            }
        }
    };
}
